var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._m(0),_c('div',{staticClass:"boton"},[_c('b-button',{staticClass:"px-4",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_vm._v("Ingresar")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leyenda"},[_c('p',[_vm._v("Registros")]),_c('p',[_vm._v("Promocionales")])])
}]

export { render, staticRenderFns }